import Properties from "../ui/widgets/Properties";
import { List } from "../../lib/ui/List";
import { C } from "../../lib/ui/constructors";
var text_link = C.text_link;
var link = C.link;
var space = C.space;
var italic = C.italic;
var hboxc = C.hboxc;
export class WikiPage extends Properties {
    constructor() {
        super();
        this.render();
    }
    image(url, caption) {
        this.row(hboxc(C.img(url).css2({ "max-width": "200px", margin: "0 auto" })));
        if (caption)
            this.row(hboxc(italic(caption).css("font-size", "0.9em")));
    }
    seeAlso(entries) {
        this.header("See Also");
        const list = new List();
        this.row(list);
        for (const entry of entries) {
            list.item(typeof entry.action == "function" ? text_link(entry.name, entry.action) : link(entry.action).text(entry.name), space(), entry.comment ? `(${entry.comment})` : undefined);
        }
        return [];
    }
    todo() {
        this.paragraph(italic("This page is yet to be written."));
    }
}
(function (WikiPage) {
    function placeholder() {
        return new class extends WikiPage {
            render() {
                this.todo();
            }
        };
    }
    WikiPage.placeholder = placeholder;
})(WikiPage || (WikiPage = {}));
